<template>
      <div class="about">
           <div class="LeftMenu">
               <div class="menuList"v-for="(itemAbout,indexAbout) in AboutArray" :key="indexAbout"
                    :class="itemAbout.id === activeChoose ? 'choose-active' : ''" @click="choose(itemAbout)">{{itemAbout.name}}</div>
           </div>
           <div class="rightContent">
                <template v-if="activeChoose==='1'">
                    <div class="aboutElegance" v-for="(itemOne,indexOne) in aboutElegance" :key="indexOne">{{itemOne}}</div>
                </template>
                <template v-if="activeChoose==='2'">
                  <div class="aboutElegance" v-for="(itemOne,indexOne) in aboutElegance" :key="indexOne">{{itemOne}}</div>
                </template>
                <template v-if="activeChoose==='3'">
                  <div class="aboutElegance">敬请期待</div>
                </template>
                <template v-if="activeChoose==='4'">
                  <div class="info" v-for="(itemInfo,indexInfo) in information" :key="indexInfo" @click="infoClick(itemInfo)">
                       <div class="title">{{itemInfo.title}}</div>
                       <img :src="itemInfo.img" class="infoImg">
                  </div>
                </template>
                <template v-if="activeChoose==='5'">
                  <div class="aboutElegance">敬请期待</div>
                </template>
           </div>
      </div>
</template>

<script>

export default {
  name: 'about',
  data () {
    return {
      activeChoose: '1',
      AboutArray:[
        {
          name:'关于雅致',
          id:'1',
        },
        {
          name:'品牌故事',
          id:'2',
        },
        {
          name:'科研实力',
          id:'3',
        },
        {
          name:'雅致资讯',
          id:'4',
        },
        {
          name:'品牌荣耀',
          id:'5',
        },
      ],
      aboutElegance:['雅致医疗致力于守护每一位中国妈妈的盆底健康，绽放自信优雅与精致。','雅致产后修复移动医疗解决方案，打破传统产后修复评估及治疗的时间和空间限制。在医院、产康中心大型治疗设备的基础上，创新治疗场景，让患者居家即可轻松完成盆底的评估与治疗康复。','降低患者综合治疗成本、更好的保护患者隐私、提供更智能的定制化治疗方案，提高患者依从性。','专业产康师1V1为客户定制最优治疗方案，对个案更有针对性评估与治疗，安全有效地提升盆底健康状况，守护您的优雅健康与自信。','“专业家用产后修复品牌”',],
      brandStory:['雅致医疗致力于守护每一位中国妈妈的盆底健康，绽放自信优雅与精致。','雅致产后修复移动医疗解决方案，打破传统产后修复评估及治疗的时间和空间限制。在医院、产康中心大型治疗设备的基础上，创新治疗场景，让患者居家即可轻松完成盆底的评估与治疗康复。','降低患者综合治疗成本、更好的保护患者隐私、提供更智能的定制化治疗方案，提高患者依从性。','专业产康师1V1为客户定制最优治疗方案，对个案更有针对性评估与治疗，安全有效地提升盆底健康状况，守护您的优雅健康与自信。','“专业家用产后修复品牌”',],
      information:[
        {
          img:require('../assets/info1.png'),
          title:'雅致医疗年会：以质量树口碑，以服务得人心',
          url:'https://www.163.com/news/article/HVSLTRQO00019UD6.html',
          id:'01',
        },{
          img:require('../assets/info2.png'),
          title:'雅致医疗开展“关注盆底健康，呵护女性幸福',
          url:'https://news.sina.com.cn/sx/2023-03-15/detail-imykxtwx4833459.shtml',
          id:'02',
        },
      ],
    }
  },
  beforeMount() {

  },
  methods: {
    choose(item){
      this.activeChoose = item.id
    },
    infoClick(item){
      window.open(item.url, '_blank')
    }
  },
}
</script>

<style scoped>
.about{
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  padding: 0% 0%  0% 10%;
  box-sizing: border-box;
  display: flex;
}
.LeftMenu {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding-top: 4%;
  box-sizing: border-box;
}

.menuList {
  font-size: 0.3rem;
  padding: 0.2rem 0.1rem;
  background: #f1efef;
  color: #5a5959;
  margin-bottom: 0.1rem;
  cursor: pointer;
}

.choose-active {
  color: #fff;
  background: #cc9f59;
  margin-bottom: 0.2rem;
}

.rightContent {
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  padding:4% 10% 4% 4%;
  box-sizing: border-box;
}

.aboutElegance {
  font-size: 0.34rem;
  margin-bottom: 0.3rem;
  color: #333;
}
.info {
  display: flex;
  background: #fff;
  border-radius: 0.15rem;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  margin-bottom: 0.6rem;
  padding: 0.2rem;
  align-items: center;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}
.title {
  font-size: 0.45rem;
  color: #333;
  margin: 0 0.3rem;
}
.infoImg {
  width: 7rem;
  border-radius: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue